import { ActionContext, ActionTree } from 'vuex'
import { EventStateInterface } from 'src/store/event/state'
import { StoreInterface } from 'src/store'
import {
  QUERY_GET_EVENT,
  QUERY_GET_ALL_EVENTS,
  QUERY_INSERT_EVENT,
  QUERY_UPDATE_EVENT,
  QUERY_DELETE_EVENT,
  QUERY_GET_FIRST3_EVENTS
} from 'src/lib/queries/event'
import { MutationOptions, QueryOptions } from 'apollo-client'
import { apolloProvider } from 'boot/apollo'
import { DocumentNode } from 'apollo-link'
import { EventId } from 'able-lib'

const actions: ActionTree<EventStateInterface, StoreInterface> = {
  async getEvent ({ commit }: ActionContext<EventStateInterface, StoreInterface>, eventId: EventId): Promise<void> {
    const options: QueryOptions = {
      query: QUERY_GET_EVENT,
      variables: {
        eventId
      },
      fetchPolicy: 'no-cache'
    }

    const { data } = await apolloProvider.defaultClient.query(options)

    commit('SET_EVENT_DRAFT', data.event)
  },

  async getEvents ({ commit }: ActionContext<EventStateInterface, StoreInterface>): Promise<any> {
    const options: QueryOptions = {
      query: QUERY_GET_ALL_EVENTS,
      fetchPolicy: 'no-cache'
    }

    const { data } = await apolloProvider.defaultClient.query(options)

    commit('SET_EVENTS', data.events)
  },

  async upsertEvent ({ state }: ActionContext<EventStateInterface, StoreInterface>): Promise<Event> {
    const eventDraft = state.eventDraft

    let mutation: DocumentNode = null
    let variables: { [key: string]: any } = {}

    if (eventDraft.id) {
      mutation = QUERY_UPDATE_EVENT
      variables = {
        id: eventDraft.id,
        type: eventDraft.type,
        name: eventDraft.name,
        startDateTime: eventDraft.startDatetime ? new Date(eventDraft.startDatetime).toISOString() : null,
        endDateTime: eventDraft.endDatetime ? new Date(eventDraft.endDatetime).toISOString() : null
      }
    } else {
      mutation = QUERY_INSERT_EVENT
      variables = {
        type: eventDraft.type,
        name: eventDraft.name,
        startDateTime: eventDraft.startDatetime ? new Date(eventDraft.startDatetime).toISOString() : null,
        endDateTime: eventDraft.endDatetime ? new Date(eventDraft.endDatetime).toISOString() : null
      }
    }

    const options: MutationOptions = {
      mutation,
      variables,
      fetchPolicy: 'no-cache'
    }

    const { data } = await apolloProvider.defaultClient.mutate(options)

    if (eventDraft.id) {
      return data.updatedEvent
    } else {
      return data.newEvent
    }
  },

  async deleteEvent ({ state }: ActionContext<EventStateInterface, StoreInterface>) {
    const eventDraft = state.eventDraft

    let mutation: DocumentNode = null
    let variables: { [key: string]: any } = {}

    mutation = QUERY_DELETE_EVENT
    variables = {
      id: eventDraft.id
    }

    const options: MutationOptions = {
      mutation,
      variables,
      fetchPolicy: 'no-cache'
    }

    await apolloProvider.defaultClient.mutate(options)
  },

  async getFirst3Events (): Promise<any> {
    const date = new Date().setHours(0, 0, 0, 0)
    const options: QueryOptions = {
      query: QUERY_GET_FIRST3_EVENTS,
      variables: {
        dateNow: new Date(date).toISOString()
      },
      fetchPolicy: 'no-cache'
    }

    const { data } = await apolloProvider.defaultClient.query(options)

    return data.event
  }

}

export default actions
